import { gatherNormalizedCitations } from './normalizeMessages';
import { extractCitationsFromSourcesList } from './resolveCitations';

// Build a cite-id -> title map for resolving [cite-xxx] markers that live
// *outside* normalized messages — specifically AUQ tool input in activeTools,
// which never passes through resolveCitations. Kept separate from
// normalizeMessages so that function stays single-purpose; re-walking the
// citation set is cheap (a conversation has well under 10 messages).
export function collectCitationTitles(messages, resolveCitationUrl) {
  const titles = new Map();
  const {
    filtered,
    allCitations
  } = gatherNormalizedCitations(messages, undefined, resolveCitationUrl);
  // Mirror resolveCitations' precedence: SourcesList web citations win over
  // preExtracted (tool-result + app) citations, so set the base first.
  for (const citation of allCitations) {
    if (citation.title) titles.set(citation.id, citation.title);
  }
  for (const citation of extractCitationsFromSourcesList(filtered)) {
    if (citation.title) titles.set(citation.id, citation.title);
  }
  return titles;
}